import { Formik } from "formik"
import { useObjectCard } from "../../context/ObjectCardProvider";
import * as apiObject from "api/apiObjects";
import { useSettings } from "context/SettingsContext";
import { useToast } from "context/ToastContext";
import { useTranslation } from "react-i18next";
import AddServiceForm from "../AddServiceModal/AddServiceForm";
import vconst from "utils/helpers/structs/vconst";
 
const initForm = {
    amount      : 0,
    amountRate  : 0,
    description : ''
}

const AddExpendFormik = ({refFormik, setSubmittingFormik, setShowObject, income}) =>{ 

    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { fetchObject, objectId} = useObjectCard();
    const { localSettings } = useSettings();
 
    return (
        <Formik 
            innerRef={refFormik}
            initialValues={{
                ...initForm,
                expendTypeId : income ? vconst.expendTypeDefIncome : vconst.expendTypeDefExpend
            }}
            onSubmit={async (values, {setSubmitting}) => {

                if ((values.amount == 0) || (values.amount == ''))
                    return showToast(t('messErrorExpand'), 'danger');

                setSubmittingFormik(true);
                const expendData = {
                    ...values,
                    objectId, 
                    amount : (income?1:-1) * values.amount,                
                    amountRate : (income?1:-1) * values.amount * (localSettings?.RATE?.current||1)
                }

                const resExpend = await apiObject.addExpend(expendData);
                await fetchObject();
                setShowObject(false);
                setSubmittingFormik(false);

                if (resExpend) 
                    income ? showToast(t('messIncomeAdded'), 'success') : showToast(t('messExpendAdded'), 'success')
                    else showToast(t('common:messError'), 'danger');

                 
            }}>

            {({handleSubmit, isSubmitting, setFieldValue, values}) => (
                <AddServiceForm 
                    titleAmount={income?t('addExpend.amountIncome'):t('addExpend.amountExpend')}
                    values={values}
                    isSubmitting={isSubmitting}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    forTeam={false}
                    income={income}/>
            )}

            
        </Formik>
    )
}

export default AddExpendFormik;